import { render, staticRenderFns } from "./changemoney.vue?vue&type=template&id=0b3b18b3"
import script from "./changemoney.vue?vue&type=script&lang=js"
export * from "./changemoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports